// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"cta-button-rework_ctaButton_31W"};